import {
  HYDRATE_FROM_LOCAL_STORE,
  GET_VENDORS_SUCCESS,
  GET_VENDOR_AUTH_PARAMS_SUCCESS,
  GET_VENDOR_ENDPOINT_PARAMS_SUCCESS,
} from '../../constants/actionTypes';

const initialState = {
  vendors: {
    lastUpdated: null,
  },
  endpoints: {
    lastUpdated: null,
  },
  authParams: {
    lastUpdated: null,
  },
};

export const vendorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE_FROM_LOCAL_STORE:
      return hydrateVendorsFromStore(state, action);

    case GET_VENDORS_SUCCESS:
      return saveVendors(state, action);

    case GET_VENDOR_AUTH_PARAMS_SUCCESS:
      return saveAuthParams(state, action);

    case GET_VENDOR_ENDPOINT_PARAMS_SUCCESS:
      return saveEndpointParams(state, action);

    default:
      return state;
  }
};

export default vendorsReducer;

function hydrateVendorsFromStore(state, action) {
  //TODO: don't refresh vendor fetched timeline. This will force refetch of vendor
  // data once after local storage hydration
  //Ideally we should have an action for force loading things after user session is restored from local storage
  return state;
  // let { vendors, result } = action;
  // if (!vendors || !has(vendors, 'vendors.lastUpdated') || !result) {
  //   return {
  //     ...state
  //   };
  // }
  //
  // const vendorLastUpdated = vendors.vendors.lastUpdated;
  // return {
  //   ...state,
  //   vendors: {
  //     lastUpdated: vendorLastUpdated
  //   }
  // };
}

function saveVendors(state, action) {
  const { receivedAt } = action;

  return {
    ...state,
    vendors: {
      lastUpdated: receivedAt,
    },
  };
}

function saveAuthParams(state, action) {
  const { receivedAt } = action;

  return {
    ...state,
    authParams: {
      lastUpdated: receivedAt,
    },
  };
}

function saveEndpointParams(state, action) {
  const { receivedAt } = action;

  return {
    ...state,
    endpoints: {
      lastUpdated: receivedAt,
    },
  };
}
